module.exports = __webpack_public_path__ + "static/img/enterpriseBig2.6fa2a11c.png";